import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuSelecionadoService {
  public menuSelecionadoSource = new BehaviorSubject<number | null>(null);
  menuSelecionado$ = this.menuSelecionadoSource.asObservable();

  constructor() {}

  selecionarMenu(menuId: number) {
    this.menuSelecionadoSource.next(menuId);
  }
}
